<template>
  <div class="role column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div>角色名称：</div>
        <div class="width300">
          <el-input placeholder="请输入角色名称" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left20" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="flex1"></div>
        <div class="btn-blue width140 btn-height40 margin-left20" @click="clickAdd" v-if="canOperate">
          <el-icon>
            <plus/>
          </el-icon>
          新建
        </div>
      </div>
      <div class="margin-top20">
        <el-table :data="tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column prop="name" label="角色名" align="center"></el-table-column>
          <el-table-column prop="remark" label="描述" align="center"></el-table-column>
          <el-table-column label="操作列" align="left" width="450" v-if="canOperate">
            <template #header>
              <div class="margin-left20">操作列</div>
            </template>
            <template #default="scope">
              <div class="row-me center-all" v-if="!scope.row.isDefaultRole">
                <div class="btn-blue width140 btn-height40" @click="clickEditAuth(scope.row)">
                  <el-icon>
                    <edit/>
                  </el-icon>
                  编辑权限
                </div>
                <div class="btn-blue width100 btn-height40 margin-left20" @click="clickEdit(scope.row)">
                  <el-icon>
                    <edit/>
                  </el-icon>
                  修改
                </div>
                <div class="btn-grey width100 btn-height40 margin-left20"
                     @click="clickDelete(scope.row)">
                  <el-icon>
                    <delete/>
                  </el-icon>
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="margin-top20">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>


    <!-- 新建修改角色 -->
    <el-dialog :title="selectItem.id?'修改角色':'新建角色'" v-model="visibleAdd" width="40%" top="20vh"
               :destroy-on-close="true">
      <div class="padding20">
        <div class="row-me row-center">
          <div><span class="red-star">*</span>角色名称：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入角色名称" style="width: 100%;" clearable v-model="selectItem.name"
                      :class="{'red-border':showRedBorder&&(selectItem.name===''||selectItem.name===null)}"
                      maxlength="50">
            </el-input>
          </div>
        </div>
        <div class="row-me margin-top30">
          <div><span class="red-star-div"></span>角色描述：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入角色描述" type="textarea" style="width: 100%;" clearable
                      v-model="selectItem.remark" maxlength="500">
            </el-input>
          </div>
        </div>
        <div class="row-me row-center flex-end1 margin-top100">
          <div class="btn-blue width140 btn-height40" @click="clickSave">保存</div>
          <div class="btn-grey width140 btn-height40 margin-left20" @click="clickCancel">取消</div>
        </div>
      </div>
    </el-dialog>


    <!-- 编辑权限 -->
    <el-dialog title="编辑权限" v-model="authVisible" width="50%" top="5vh" :destroy-on-close="true">
      <div class="dialog-content1 column-me">
        <div style="overflow: auto;">
          <el-tree ref="authTree" :data="treeData" show-checkbox node-key="id" default-expand-all
                   :expand-on-click-node="true" :check-strictly="false" :props="treeProps">
            <template #default="{ node, data }">
              <div class="row-me row-center" style="width: 300px;color: #252630;">
                <div class="font-size18 flex1">{{ node.label }}</div>
                <div class="row-me row-center margin-left80" v-if="data.parentId!==0">
                  <el-checkbox v-model="data.operate" label="可编辑" size="large" @change="e=>operateChange(e,data)"/>
                </div>
              </div>
            </template>
          </el-tree>
        </div>
        <div class="flex1"></div>
        <div class="row-me row-center flex-end1 margin-top20">
          <div class="btn-blue width110 btn-height40" @click="clickSaveAuth">保存</div>
          <div class="btn-grey width110 btn-height40 margin-left20" @click="clickCancelAuth">取消</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: '',
      tableData: [],
      visibleAdd: false,
      selectItem: {
        name: '',
        remark: '',
      },
      showRedBorder: false,
      authVisible: false,
      treeData: [],
      treeProps: {
        children: 'children',
        label: 'name',
      },
      pageNo: 1,
      total: 0,
      canOperate: false,
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.pageNo = 1
    this.getRoleList()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    operateChange(e, item) {
      if (item.parentId === 0) {//一级
        for (let child of item.children) {
          child.operate = e
        }
      }
    },
    //新建
    clickAdd() {
      this.selectItem = {
        name: '',
        remark: '',
      }
      this.visibleAdd = true
    },
    //查询
    clickSearch() {
      this.pageNo = 1
      this.getRoleList()
    },
    //清空
    clickClear() {
      this.name = ''
      this.pageNo = 1
      this.getRoleList()
    },
    //编辑权限
    clickEditAuth(item) {
      this.getAllPermission()
      this.selectItem = this.$method.deepClone(item)
      this.authVisible = true
    },
    //编辑
    clickEdit(item) {
      this.selectItem = this.$method.deepClone(item)
      this.visibleAdd = true
    },
    //删除
    clickDelete(item) {
      this.$confirm("您确定要删除【" + item.name + "】吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/newRole/delete', [item.id]).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.pageNo = 1
            this.getRoleList()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //保存
    clickSave() {
      if (this.selectItem.name === '') {
        this.showRedBorder = true
        return
      }
      this.$postRequest('/admin/newRole/update', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleAdd = false
          this.pageNo = 1
          this.getRoleList()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消
    clickCancel() {
      this.visibleAdd = false
    },
    //保存权限
    clickSaveAuth() {
      //获取可操作
      let checkedNodes = this.$refs.authTree.getCheckedNodes(false, true)
      this.$postRequest('/admin/newRole/editRolePermission', {
        roleId: this.selectItem.id,
        permissionIds: checkedNodes,
      }).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.authVisible = false
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消权限
    clickCancelAuth() {
      this.authVisible = false
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //获取角色列表
    getRoleList() {
      this.$getRequest('/admin/role/page', {
        name: this.name,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取权限列表
    getAllPermission() {
      this.$getRequest('/admin/role/getAllPermission', {}).then((res) => {
        if (res) {
          this.treeData = res.data
          this.getAuthList()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取已经有的权限
    getAuthList() {
      this.$getRequest('/admin/newRole/getRolePermission/' + this.selectItem.id, {}).then((res) => {
        if (res) {
          let lookIds = res.data.filter(item => {
            return (item.level === 0 && item.url === '/home') || (item.level !== 0)
          }).map(obj => {
            return obj.id
          })
          let operateIds = res.data.filter(item => {
            return item.operate
          }).map(item => {
            return item.id
          })
          this.$nextTick(() => {
            this.$refs.authTree.setCheckedKeys(lookIds, false)
          })
          //设置可编辑的
          for (let item1 of this.treeData) {
            item1.operate = operateIds.indexOf(item1.id) !== -1
            for (let item2 of item1.children) {
              item2.operate = operateIds.indexOf(item2.id) !== -1
            }
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.role {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .dialog-content1 {
    height: 70vh;
    padding: 20px 50px 30px 150px;
    font-size: 18px;
    color: #222222;
  }
}
</style>
